<template>
  <div class="flex items-center flex-wrap">
    <div class="w-full flex flex-col items-center mb-24 text-center">
      <h1 class="font-bold text-2xl mb-4">Apăsați pe butonul de mai jos pentru a finaliza plata.</h1>
      <form name="frmPaymentRedirect" method="post" :action="payment_url">
        <input type="hidden" name="env_key" :value="env_key"/>
	      <input type="hidden" name="data" :value="enc_data"/>
        <button type="submit" class="btn-gray mt-8">Mergi la plată</button>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo () {
    return {
      title: 'Finalizare comandă',
    }
  },
  layout: Layout,
  components: {
    Layout,
  },
  props: ['order', 'env_key', 'enc_data', 'payment_url'],
  computed: {
    paymentMethod() {
      return Object.values(this.$page.constants.order.payment_methods).filter( (status) => {
        return status.value == this.order.payment_method
      })[0]
    },
    deliveryOption() {
      return Object.values(this.$page.constants.order.delivery_options).filter( (status) => {
        return status.value == this.order.delivery_option
      })[0]
    }
  }
}
</script>
